import { ButtonField, NotificationContainer, Notification, NotificationActions  } from '@wk/components-react16';

const DeleteConfirm = ({ data }: any) => {
    const { isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message } = data;

    return (
         <NotificationContainer>
              <Notification
                controlMode="controlled"
                isOpen={isOpenDeleteConfirm}
                mode="toast"
                hasCloseButton
                heading={'Confirmation'}
                onUserRequest={(event: any) =>
                  setIsOpenDeleteConfirm(false)
                }
                type="warning"
                >
                <span slot="notificationContent">
                  {message}
                </span>
                <NotificationActions slot="notificationActions">
                  <ButtonField mode={'text'} size={'small'}>
                    <button type="button" onClick={() => deleteItem()}>Yes</button>
                  </ButtonField>
                  <ButtonField mode={'text'} size={'small'}>
                    <button type="button" onClick={() => setIsOpenDeleteConfirm(false)}>No</button>
                  </ButtonField>
                </NotificationActions>
              </Notification>
        </NotificationContainer>
    );
};

export default DeleteConfirm;
